import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Status } from '../../classess/status/status';
import { BackupReview } from '../../classess/backupReview/backupReview';
import { BackupReviewDetail } from '../../classess/backupReview/backupReviewDetail';

import {
    badgetStatusGeneric, getProcessButtons, setDateTimeFormatGlobalString, isUndNullEmp, getLanguageObj, getResponse, getRolesType, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { BackupReviewService } from '../../services/backupReviews/BackupReviewService';

const currentMethod = 'BackupReviewDetailAddEditDetail';

export default function BackupReviewDetailAddEditDetail({
    // auth = {},
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtBackupReviewDetailsId: '',
        dtBackupReviewDetailsRowId: 0,
        backupReview: BackupReview?.getClass({}, false),
        backupReviewDetail: BackupReviewDetail?.getClass({}, false),
        brdFieldViews: {
            status: {
                label: '',
                badget: '',
            },
            scheduledDate: {
                date: '',
                time: ''
            },
            executionDate: {
                date: '',
                time: ''
            },
            commentary: '',
        },
        status: [Status?.getClass({}, false)],
        userRoles: getRolesType(),
    },
    setModalObj = {},
    setShowData = undefined,
}) {
    //#region variables
    const isMount = useRef(false);
    const inpScheduledDateRef = useRef(null);
    const inpExecutionDateRef = useRef(null);
    const txtAreaCommentaryRef = useRef(null);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const [errors, setErrors] = useState({
        status: '',
        scheduledDate: '',
        executionDate: '',
        commentary: '',
    });
    const [dataFormLength] = useState(BackupReviewDetail.minMaxLength(false));

    const { icons, images, labels, messages } = settings;

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            scheduledDate: {
                id: 'inputModalScheduledDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
            executionDate: {
                id: 'inputModalExecutionDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
            },
        },
        pickers: {
            scheduledDate: {
                id: 'pkModalScheduledDate',
            },
            executionDate: {
                id: 'pkModalExecutionDate',
            },
        },
        selects: {
            status: {
                id: 'selModalStatus',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
                //style: { borderRadius: '10px' }
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
        textAreas: {
            commentary: {
                id: 'txtAreaModalCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
                //style: { borderRadius: '10px' }
            }
        }
    };
    //#endregion variables

    //#region methods
    //#region backupreviewdetails
    const addBackupReviewDetail = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'addBackupReviewDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const setDataBackupReviewDetail = response?.result?.backupReviewDetail || modalObj?.backupReviewDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await BackupReviewService.addDetailAsync({
                auth: modalObj?.auth,
                backupReviewDetail: setDataBackupReviewDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            // Sync with DataTable
            const newDetail = response?.result?.backupReviewDetail || {};
            const modelBackupReviewDetail = BackupReviewDetail?.getClass(newDetail, false);
            const statusModel = Status?.getClass(modalObj?.status?.find(({ id }) => id === modelBackupReviewDetail?.statusId) || {}, false);

            const scheduledDate = setDateTimeFormatGlobalString({
                date: modelBackupReviewDetail?.scheduledDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            const executionDate = setDateTimeFormatGlobalString({
                date: modelBackupReviewDetail?.executionDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            const statusLabel = statusModel?.label || `${statusModel?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${statusModel?.name?.replace(' ', '')?.slice(1)}`;
            const statusBadge = badgetStatusGeneric({
                type: [1, 5, 3, 0, -1, 2][(statusModel?.id || 5) - 1] ?? (statusModel?.id || 5),
                value: labels?.[statusLabel]?.[modalObj?.languageObj?.id] || labels?.undefined?.[modalObj?.languageObj?.id],
            });

            const buttonDescription = `${scheduledDate} - ${executionDate} - ${statusLabel}`;

            modalObj?.$(`#${modalObj.dtBackupReviewDetailsId}`).DataTable().row.add([
                modelBackupReviewDetail?.scheduledDate,
                scheduledDate,
                executionDate,
                statusBadge,
                modelBackupReviewDetail?.commentary || '',
                getProcessButtons({
                    id: modelBackupReviewDetail.id,
                    description: buttonDescription,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const editBackupReviewDetail = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editBackupReviewDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const currentBackupReviewDetail = response?.result?.backupReviewDetail || modalObj?.backupReviewDetail;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await BackupReviewService.editDetailAsync({
                auth: modalObj?.auth,
                backupReviewDetail: currentBackupReviewDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            // Sync with DataTable
            const updatedDetail = response?.result?.backupReviewDetail || modalObj?.backupReviewDetail;
            const modelBackupReviewDetail = BackupReviewDetail?.getClass(updatedDetail, false);
            const statusModel = Status?.getClass(modalObj?.status?.find(({ id }) => id === modelBackupReviewDetail?.statusId) || {}, false);

            const scheduledDate = setDateTimeFormatGlobalString({
                date: modelBackupReviewDetail?.scheduledDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            const executionDate = setDateTimeFormatGlobalString({
                date: modelBackupReviewDetail?.executionDate,
                dateFormat: modalObj?.languageObj?.format?.date?.f1,
                timeFormat: 0,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            const statusLabel = statusModel?.label || `${statusModel?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${statusModel?.name?.replace(' ', '')?.slice(1)}`;
            const statusBadge = badgetStatusGeneric({
                type: [1, 5, 3, 0, -1, 2][(statusModel?.id || 5) - 1] ?? (statusModel?.id || 5),
                value: labels?.[statusLabel]?.[modalObj?.languageObj?.id] || labels?.undefined?.[modalObj?.languageObj?.id],
            });

            const buttonDescription = `${scheduledDate} - ${executionDate} - ${statusLabel}`;

            modalObj?.$(`#${modalObj?.dtBackupReviewDetailsId}`).DataTable().row(modalObj?.dtBackupReviewDetailsRowId).data([
                modelBackupReviewDetail?.scheduledDate,
                scheduledDate,
                executionDate,
                statusBadge,
                modelBackupReviewDetail?.commentary || '',
                getProcessButtons({
                    id: modelBackupReviewDetail.id,
                    description: buttonDescription,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }
    //#endregion backupreviewdetails

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region set data input timers
            response = setDateInControl({
                _date: new Date().toISOString(),
                _scheduledDate: modalObj?.backupReviewDetail?.scheduledDate,
                _executionDate: modalObj?.backupReviewDetail?.executionDate,
                subMethod: currentMethod,
            });
            //#endregion set data input timers
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(`Method: ${currentMethod}, Sub method: ${subMethod}, Error: ${ex?.message}`);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const scheduledStr = inpScheduledDateRef.current?.value || '';
            const executionStr = inpExecutionDateRef.current?.value || '';
            const commentaryStr = txtAreaCommentaryRef.current?.value || '';

            const timeFormat = modalObj?.languageObj?.format?.time?.type === 12 ? modalObj?.languageObj?.format?.time?.f2 : modalObj?.languageObj?.format?.time?.f1;
            const dateTimeFormat = `${modalObj?.languageObj?.format?.date?.f11} ${timeFormat}`;

            const scheduled = moment(scheduledStr, dateTimeFormat);
            const execution = moment(executionStr, dateTimeFormat);

            const requiredMsg = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            if (!modalObj?.backupReviewDetail?.statusId || modalObj?.backupReviewDetail?.statusId <= 0) {
                setErrors(prev => ({ ...prev, status: requiredMsg }));
                response = getResponse({ type: 1 });
            }

            if (!scheduledStr || !scheduled.isValid()) {
                setErrors(prev => ({ ...prev, scheduledDate: requiredMsg }));
                response = getResponse({ type: 1 });
            }

            if (!executionStr || !execution.isValid()) {
                setErrors(prev => ({ ...prev, executionDate: requiredMsg }));
                response = getResponse({ type: 1 });
            }

            if (!commentaryStr) {
                setErrors(prev => ({ ...prev, commentary: requiredMsg }));
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                status: '',
                scheduledDate: '',
                executionDate: '',
                commentary: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            const scheduledDate = modalObj?.$(`#${controls?.pickers?.scheduledDate?.id}`).datetimepicker('date')?._d;
            const executionDate = modalObj?.$(`#${controls?.pickers?.executionDate.id}`).datetimepicker('date')?._d;

            const format = `${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}.000Z`;

            const setDataBackupReviewDetail = {
                ...modalObj?.backupReviewDetail,
                scheduledDate: moment(scheduledDate).format(format),
                executionDate: moment(executionDate).format(format),
                commentary: txtAreaCommentaryRef.current?.value || '',
            };

            setModalObj(prev => ({
                ...prev,
                backupReviewDetail: setDataBackupReviewDetail
            }));

            response.result = { backupReviewDetail: setDataBackupReviewDetail };
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        _date = undefined,
        _scheduledDate = undefined,
        _executionDate = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            const tf = modalObj?.languageObj?.format?.time?.type;
            const df = modalObj?.languageObj?.format?.date?.f1;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;

            const scheduledDate = _scheduledDate ?
                setDateTimeFormatGlobalString({ date: _scheduledDate, dateFormat: df, timeFormat: tf, withSeconds: false })?.result :
                setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false })?.result;

            const executionDate = _executionDate ?
                setDateTimeFormatGlobalString({ date: _executionDate, dateFormat: df, timeFormat: tf, withSeconds: false })?.result :
                setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false })?.result;

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj?.$.extend({}, modalObj?.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            modalObj?.$(`#${controls?.pickers?.scheduledDate?.id}`).datetimepicker('options', {
                date: scheduledDate,
                default: false,
                timepicker: true,
                format: dtf,
            });

            modalObj?.$(`#${controls?.pickers?.executionDate.id}`).datetimepicker('options', {
                date: executionDate,
                default: false,
                timepicker: true,
                format: dtf,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='backupReviews' src={images?.icons?.backupReviews} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.backupReviewDetail?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.showLoading}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <Modal.Body className='p-0'>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.list} /> {labels?.status?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='input-group'>
                                            <select id={controls?.selects?.status?.id}
                                                disabled={process?.showLoading || (modalObj?.type !== 0 && modalObj?.type !== 1) || process?.save}
                                                className='custom-select bg-light border-0 shadow-sm text-dark'
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.backupReviewDetail?.statusId, subMethod: controls?.selects?.status?.id })?.result ? modalObj?.backupReviewDetail?.statusId : 0}
                                                onChange={(e) => setModalObj({ ...modalObj, backupReviewDetail: { ...modalObj?.backupReviewDetail, statusId: parseInt(e?.currentTarget?.value) } })}
                                                onFocus={() => setErrors(prev => ({ ...prev, status: '' }))}
                                                title={labels?.status?.[modalObj?.languageObj?.id]}>
                                                <option key='nothing' value='0'>{messages?.selectStatus?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.status?.map((status) => (
                                                    <option key={status.id} value={status.id}>
                                                        {!isUndNullEmp({ data: status?.label, subMethod: controls?.selects?.status?.id })?.result ?
                                                            labels?.[status?.label]?.[modalObj?.languageObj?.id] :
                                                            labels?.[`${status?.name?.replaceAll(' ', '')?.charAt(0)?.toLowerCase()}${status?.name?.replaceAll(' ', '')?.slice(1)}`]?.[modalObj?.languageObj?.id] || 'undefined'
                                                        }
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.status)}</div>
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 mb-3' hidden={!modalObj?.userRoles?.isAdmin && !modalObj?.userRoles?.isAnalyst}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.backupReviewDetail?.scheduledDate, subMethod: controls?.inputs?.scheduledDate?.id })?.result && (
                                            <div id={controls?.pickers?.scheduledDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.scheduledDate?.id}
                                                    ref={inpScheduledDateRef}
                                                    className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.showLoading || process?.save}
                                                    data-target={`#${controls?.pickers?.scheduledDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, scheduledDate: '' }))}
                                                    placeholder={labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.scheduledDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.scheduledDate)}</div>
                                    </div>
                                </div>

                                <div className='col-12 col-md-6 mb-3' hidden={!modalObj?.userRoles?.isAdmin && !modalObj?.userRoles?.isAnalyst}>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.executionDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.backupReviewDetail?.executionDate, subMethod: controls?.inputs?.executionDate?.id })?.result && (
                                            <div id={controls?.pickers?.executionDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.executionDate?.id}
                                                    ref={inpExecutionDateRef}
                                                    className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.showLoading || process?.save}
                                                    data-target={`#${controls?.pickers?.executionDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, executionDate: '' }))}
                                                    placeholder={labels?.executionDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.executionDate?.[modalObj?.languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.executionDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.executionDate)}</div>
                                    </div>
                                </div>

                                <div className='col-12 mb-0'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.edit} /> {labels?.commentary?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <textarea id={controls?.textAreas?.commentary?.id}
                                            ref={txtAreaCommentaryRef}
                                            className='form-control bg-light border-0 shadow-sm text-dark'
                                            style={{ minHeight: '100px', borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.commentary}
                                            disabled={process?.showLoading || process?.save}
                                            placeholder={labels?.commentary?.[modalObj?.languageObj?.id]}
                                            onChange={(e) => setModalObj({ ...modalObj, backupReviewDetail: { ...modalObj?.backupReviewDetail, commentary: e?.target.value } })}
                                            onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                            rows={2}
                                            value={modalObj?.backupReviewDetail?.commentary || ''}
                                            title={labels?.commentary?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.commentary)}</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                <div className='col-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.list} /> {labels?.status?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h5 mb-0 font-weight-bold'>
                                            {parse(modalObj?.brdFieldViews?.status?.badget || '')}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.brdFieldViews?.scheduledDate?.date}</span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.executionDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold'>{modalObj?.brdFieldViews?.executionDate?.date}</span>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={settings?.html?.labels?.detailMicro}>
                                        <i className={icons?.fasFa?.edit} /> {labels?.observation?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <div className='p-3 rounded bg-white border-left border-secondary shadow-sm' style={{ minHeight: '100px', fontSize: '0.95rem', lineHeight: '1.6', overflowWrap: 'break-word' }}>
                                        {modalObj?.brdFieldViews?.commentary || '---'}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button id={controls?.buttons?.save?.id}
                        className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                        style={{ borderRadius: '5px' }}
                        disabled={process?.showLoading}
                        hidden={modalObj?.type === 2}
                        onClick={(e) => modalObj?.type === 0 ?
                            addBackupReviewDetail({ e: e, subMethod: 'form', }) :
                            modalObj?.type === 1 ?
                                editBackupReviewDetail({ e: e, subMethod: 'form', }) :
                                e?.preventDefault?.()}
                        tooltip='tooltip'
                        title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        type='button'>
                        {process?.save ? (
                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                        ) : (
                            <i id={controls?.icons?.save?.id} className={icons?.fasFa?.save} />
                        )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                        style={{ borderRadius: '5px' }}
                        disabled={process?.showLoading}
                        tooltip='tooltip'
                        title={labels?.close?.[modalObj?.languageObj?.id]}
                        type='button'
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                        <i id={controls?.icons?.back?.id} className={icons?.fasFa?.arrowCircleLeft}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal >
    )
}